import React from 'react'
import Axios from 'axios'
import { PasswordWarning } from './PasswordWarning'

const NeedsToResetPassword = (props) => {
    const [firstPass, setFirstPass] = React.useState('')
    const [secondPass, setSecondPass] = React.useState('')
    const [passWarning, setPassWarning] = React.useState(false)

    React.useState(() => {
        firstPass === secondPass ? setPassWarning(false) : setPassWarning(true)
    }, [firstPass, secondPass])

    const passwordSubmit = () => {
        if(firstPass === secondPass && firstPass !== '') {
            Axios.put('https://app.atharo.app/passreset', {
                Email: props.userData.Email,
                Password: firstPass,
            })
            .then(response => {
                props.setNeedsToReset(false)
            })
            .catch(e => {
                console.log('Error Password Update did not work: ' + e)
            })
        }
    }

    return(
        <>
            <div className="login-page pass-reset-page">
                <div className="login-header">
                    Admin Portal
                </div>
                <div className="login-box">
                    <div className="login-box-title">Password Reset</div>
                    <input className="password-input login-input" type="password" placeholder="New password" onChange={e => setFirstPass(e.target.value)} ></input>
                    <input className="password-input login-input" type="password" placeholder="Confirm password" onChange={e => setSecondPass(e.target.value)} ></input>
                    {passWarning && <PasswordWarning />}
                    <div className="login-btn reset-pass-btn" onClick={() => passwordSubmit()}>Reset Password</div>
                    <div className="password-reset-explaination">Since this is your first time logging in, please enter a personalized password you can remember. Thank you!</div>
                </div>
            </div>
        </>
    )
}
export default NeedsToResetPassword